export default __webpack_public_path__ + "static/media/promo.17e7d768.jpg";